// dojo is the internal private class that
// provides a singleton instance of the Dojo manager class
let _dojoDeshi = null;

import {AutoComplete} from './AutoComplete.js';
import {ClassRecordEditor} from './ClassRecordEditor.js';
import {ClassRecordSummaryTable} from './ClassRecordSummaryTable.js';
import {ClassRecordSummaryTableController} from './ClassRecordSummaryTableController.js';
import {FormsTabContainer} from './FormsTabContainer.js';
import {FormsTabPanel} from './FormsTabPanel.js';
import {LoginForm} from './LoginForm.js';
import {StudentListController} from './StudentListController.js';
import {TechniquesAutoComplete} from './TechniquesAutoComplete.js';
import {DojoPopup} from './DojoPopup.js';

import {DataComponents} from './DataComponents.js';
import {DojoMenu} from './DojoMenu.js';
import {DojoAPIHttp} from './DojoAPI.js';
import {DojoAPIWs} from './DojoAPIWs.js';

import {DojoTabs} from './DojoTabs.js';
import {TopMenu} from './TopMenu.js';

import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

import {RPCClick} from './RPCClick.js';

export class DojoDeshi {
	constructor() {
		if (!_dojoDeshi) {
			_dojoDeshi = this;
		}
		// console.log("Document.location.protocol = ", document.location.protocol);
		console.log(`DojoAPIHttp = `, DojoAPIHttp);
		this._rpc = new DojoAPIHttp();
		this._rpcWs = new DojoAPIWs();

		// $(document).foundation();
		// $('.menu-link').bigSlide({'easyClose':true});
		// new LeftNavController(document.getElementById('left-nav'));

		DataComponents(document);

		return _dojoDeshi;
	}
	RPCHttp() {
		return this._rpc;
	}
	RPC() {
		return this._rpcWs;
	}	
	static instance() {
		if (!_dojoDeshi) {
			_dojoDeshi = new DojoDeshi();
		}
		return _dojoDeshi;
	}
}

window.DojoDeshi = DojoDeshi;

document.addEventListener('DOMContentLoaded', function() {
	DojoDeshi.instance();
});
